
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-help-center/[[...slug]]",
      function () {
        return require("private-next-pages/customer-help-center/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-help-center/[[...slug]]"])
      });
    }
  